import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '../../../elements/ActionElement';

class PaginationButton extends React.Component {
  constructor() {
    super();
    this.activateButton = this.activateButton.bind(this);
  }

  activateButton() {
    const {
      refParentTable,
      goToPageNumber,
      classNames
    } = this.props;

    goToPageNumber();

    // Set the focus to the first sibling of the navigation button:
    if (refParentTable && refParentTable.current) {
      const className = classNames.join('.');
      const oFirstSiblingDom = refParentTable.current.querySelector(`.${className}`);
      oFirstSiblingDom.focus();

      // Scroll to the sibling even if it can not be focusable anymore (e.g. it turns into "disabled"):
      window.scrollTo(0, oFirstSiblingDom.offsetTop);
    }
  }

  render() {
    const {
      props,
      activateButton
    } = this;

    const {
      isDisabled,
      classNames,
      title,
      buttonContent
    } = props;

    const attributes = {
      onClick: activateButton,
      letButtonShrink: true,
      buttonColor: isDisabled && 'gray'
    };

    if (isDisabled) {
      attributes.disabled = true;
    }

    if (classNames.length > 0) {
      attributes.className = classNames.join(' ');
    }

    if (title) {
      attributes.title = title;
    }

    return <Button {...attributes}>{buttonContent}</Button>;
  }
}

PaginationButton.propTypes = {
  buttonContent: PropTypes.element.isRequired,
  goToPageNumber: PropTypes.func.isRequired,
  classNames: PropTypes.arrayOf(PropTypes.string),
  isDisabled: PropTypes.bool,
  title: PropTypes.string,
  refParentTable: PropTypes.object
};

export default PaginationButton;